import * as yup from 'yup';

const loginSchema = yup.object().shape({
  email: yup.string().email('Insira um e-mail válido.').required('E-mail obrigatório'),
  senha: yup.string().required('Senha obrigatória.'),
});

export { loginSchema };
